import { classnames } from "../utils/general";

const CustomInput = ({ customInput, setCustomInput }) => {
  return (
    <textarea
      rows="5"
      value={customInput}
      onChange={(e) => setCustomInput(e.target.value)}
      placeholder="Custom Input"
      className={classnames(
        "mt-2 w-full rounded-sm border border-vscode-border bg-vscode-input px-2 py-1 font-mono text-xs text-vscode-text placeholder:text-vscode-textMuted focus:border-vscode-accent focus:outline-none"
      )}
    ></textarea>
  );
};

export default CustomInput;
